import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { Lunar } from 'lunar-typescript';

const EARTHLY_BRANCHES = ['子', '丑', '寅', '卯', '辰', '巳', '午', '未', '申', '酉', '戌', '亥'];

// 地支对应数字（用于年份和时辰）
const EARTHLY_BRANCHES_MAP: Record<string, number> = {
  '子': 1, '丑': 2, '寅': 3, '卯': 4, '辰': 5, '巳': 6,
  '午': 7, '未': 8, '申': 9, '酉': 10, '戌': 11, '亥': 12
};

// 农历月份地支对应数字（寅月=1，卯月=2，...）
const LUNAR_MONTH_MAP: Record<string, number> = {
  '寅': 1, '卯': 2, '辰': 3, '巳': 4, '午': 5, '未': 6,
  '申': 7, '酉': 8, '戌': 9, '亥': 10, '子': 11, '丑': 12
};

// 从干支中提取地支
function getEarthlyBranch(ganZhi: string): string {
  return ganZhi.charAt(1);
}

function getChineseHour(hour: number): string {
  const index = Math.floor((hour + 1) / 2) % 12;
  return EARTHLY_BRANCHES[index];
}

export default function LunarDateTime() {
  const [currentTime, setCurrentTime] = useState(dayjs());
  const [lunar, setLunar] = useState(Lunar.fromDate(new Date()));

  useEffect(() => {
    const timer = setInterval(() => {
      const now = dayjs();
      setCurrentTime(now);
      setLunar(Lunar.fromDate(now.toDate()));
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const currentHour = getChineseHour(currentTime.hour());
  const yearGanZhi = lunar.getYearInGanZhi();
  const monthGanZhi = lunar.getMonthInGanZhi();
  const dayGanZhi = lunar.getDayInGanZhi();
  const lunarDay = lunar.getDay(); // 农历日期的数字

  // 计算用于起卦的数字
  const yearBranch = getEarthlyBranch(yearGanZhi); // 年份的地支
  const yearNumber = EARTHLY_BRANCHES_MAP[yearBranch]; // 年份数字（1-12）

  const monthBranch = getEarthlyBranch(monthGanZhi); // 月份的地支
  const monthNumber = LUNAR_MONTH_MAP[monthBranch]; // 月份数字（寅月=1）

  const dayNumber = lunarDay; // 日期数字（直接取农历日）

  const hourNumber = EARTHLY_BRANCHES_MAP[currentHour]; // 时辰数字（1-12）

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="text-center space-y-4">
        <div className="text-gray-600">
          {yearGanZhi}年
          {monthGanZhi}月
          {dayGanZhi}日
        </div>

        <div className="text-2xl font-bold text-red-600">
          {currentHour}时
        </div>

        <div className="text-sm text-gray-500">
          {yearGanZhi}：{yearNumber} {monthGanZhi}：{monthNumber} {dayGanZhi}：{dayNumber} {currentHour}：{hourNumber}
        </div>

        <div className="text-sm text-gray-500">
          {currentTime.format('YYYY年MM月DD日 HH:mm:ss')}
        </div>
      </div>
    </div>
  );
}